export const regexp = (str: string) =>
  new RegExp(`(https?://)?(www.)?${str}`, 'i')

export const withHttps = (str: string) =>
  str.indexOf('://') === -1 && str.indexOf('mailto:') === -1
    ? 'https://' + str
    : str
